<div class="placeholder-container">
    <div class="placeholder-content">
        <div class="accuris-logo"></div>
        <h3 class="placeholder-title shimmer-text">One moment please while we are logging you in</h3>
    </div>
    <epd-spinner size="large" [isVisible]="true" [fullscreen]="false"></epd-spinner>
</div>
